import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { pt } from "date-fns/locale";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import styled from "styled-components";
import {
  fetchOpenClosedExceptions,
  fetchReservationBlockedWeekdays,
} from "../actions/reservationsActions";
import Messages from "./Messages";
import Loader from "./Loader";
import { zonedTimeToUtc, utcToZonedTime, format } from "date-fns-tz";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";

const DatePickerWrapper = styled.div`
  width: 100%;
  font-size: 1.5rem;
  justify-content: center;

  .react-datepicker {
    font-size: 16px;
    height: 370px;
    border: none;
    border-radius: 20px;
    box-shadow: none;
    padding: 10px 0;
    background-color: transparent;
  }

  .react-datepicker__header {
    background-color: transparent;
    border-bottom: 1px solid #e0e0e0;
    padding-top: 20px;
  }

  .react-datepicker__current-month {
    font-size: 20px;
    font-weight: 600;
    color: #99b0ad;
    text-align: center;
    margin-bottom: 10px;
  }

  .react-datepicker__day-names {
    margin-top: 10px;
  }

  .react-datepicker__day-name {
    color: #888;
    font-weight: 500;
    font-size: 14px;
  }

  .react-datepicker__day {
    width: 40px;
    height: 40px;
    line-height: 40px;
    font-weight: 500;
    font-size: 14px;
    margin: 2px;
    border-radius: 10px;
    position: relative;
  }

  .react-datepicker__day--selected {
    background-color: #ee754c !important;
    color: white !important;
    border-radius: 10px;
  }

  .react-datepicker__day--keyboard-selected {
    background-color: #d4d4d4;
    color: black;
  }

  .react-datepicker__day:hover {
    background-color: #f79574 !important;
    opacity: 1 !important;
    transform: none !important;
    box-shadow: none !important;
    color: white !important;
  }

  .react-datepicker__day--selected:hover {
    background-color: #ee561b !important;
  }
`;

const NavButton = styled.button`
  background-color: white;
  border: none;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  color: black;
  width: 36px;
  height: 36px;
  cursor: pointer;
  padding: 0;
  transition: all 0.2s ease;

  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: #f0f0f0;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  }

  &:focus {
    outline: none;
  }
`;

const CustomDatePicker = ({
  selectedDate,
  onDateChange,
  id,
  handleCloseDateModal = false,
}) => {
  const dispatch = useDispatch();
  const [currentTimeZone, setCurrentTimeZone] = useState("Europe/London");

  const open_closed_exceptions = useSelector(
    (state) => state.closedOpenExceptionsDatePicker
  );
  const { openClosedExceptions } = open_closed_exceptions;

  const [closedExceptions, setClosedExceptions] = useState(false);
  const [openExceptions, setOpenExceptions] = useState([]);

  useEffect(() => {
    if (openClosedExceptions) {
      setClosedExceptions(openClosedExceptions.closed_exceptions);
      setOpenExceptions(openClosedExceptions.open_exceptions);
    }
  }, [openClosedExceptions]);

  const reservationBlockedWeekDays = useSelector(
    (state) => state.reservationBlockedWeekDays
  );
  const {
    blockedWeekdays,
    isLoading,
    error,
    isRestaurantOpen,
    restaurantTimeZone,
  } = reservationBlockedWeekDays;

  useEffect(() => {
    dispatch(fetchOpenClosedExceptions(id));
    dispatch(fetchReservationBlockedWeekdays(id));
  }, [dispatch]);

  let blockedWeekdayss = [];
  if (blockedWeekdays !== undefined && blockedWeekdays !== "") {
    blockedWeekdayss = blockedWeekdays
      .split(",")
      .map((str) => parseInt(str.trim()))
      .filter((num) => !isNaN(num));
  }

  useEffect(() => {
    if (restaurantTimeZone) {
      setCurrentTimeZone(restaurantTimeZone.timezone);
    }
  }, [restaurantTimeZone]);

  let closedExceptionss = [];
  let dateObject = null;

  if (
    isRestaurantOpen &&
    isRestaurantOpen.block_day !== "No day needs to be blocked."
  ) {
    let dateParts = isRestaurantOpen.block_day.split("-");
    dateObject = new Date(+dateParts[0], +dateParts[1] - 1, +dateParts[2]);
  }

  if (closedExceptions) {
    closedExceptionss = closedExceptions.map((dateStr) => {
      const [day, month, year] = dateStr.split("-").map(Number);
      let blockedDate = new Date(year, month - 1, day);
      return utcToZonedTime(blockedDate, currentTimeZone);
    });
  }

  if (dateObject !== null) {
    closedExceptionss.push(dateObject);
  }

  const isBlocked = (date) => {
    const day = date.getDay();
    const dateStr = `${date.getDate().toString().padStart(2, "0")}-${(
      date.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}-${date.getFullYear()}`;

    const isBlockedDay =
      Array.isArray(closedExceptionss) &&
      closedExceptionss.some((blockedDate) => {
        return (
          blockedDate.getDate() === date.getDate() &&
          blockedDate.getMonth() === date.getMonth() &&
          blockedDate.getFullYear() === date.getFullYear()
        );
      });

    if (isBlockedDay) return true;

    const isNormallyBlockedWeekday = blockedWeekdayss.includes(day);
    const isOpenException = openExceptions.includes(dateStr);

    return isNormallyBlockedWeekday && !isOpenException;
  };

  const getTodayInServerTimeZone = () => {
    const now = new Date();
    const zonedNow = utcToZonedTime(now, currentTimeZone);
    zonedNow.setHours(0, 0, 0, 0);
    return zonedNow;
  };

  const minDate = getTodayInServerTimeZone();

  return (
    <DatePickerWrapper>
      {isLoading ? (
        <h2>
          <Loader />
        </h2>
      ) : blockedWeekdays ? (
        <DatePicker
          inline
          locale={pt}
          selected={selectedDate}
          dayClassName={(date) => {
            let classNames = "";

            if (isBlocked(date)) {
              classNames += " react-datepicker__day--disabled";
            } else {
              classNames += " react-datepicker__day--selectable";
            }

            return classNames.trim();
          }}
          onChange={(date) => {
            date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
            let dateInUTC = zonedTimeToUtc(date, currentTimeZone);
            onDateChange(dateInUTC);
            if (handleCloseDateModal !== false) {
              handleCloseDateModal();
            }

            if (document.activeElement instanceof HTMLElement) {
              document.activeElement.blur();
            }
          }}
          filterDate={(date) => !isBlocked(date)}
          minDate={minDate}
          renderCustomHeader={({ date, decreaseMonth, increaseMonth }) => (
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: 10,
              }}
            >
              <NavButton onClick={decreaseMonth}>
                <FontAwesomeIcon
                  icon={faChevronLeft}
                  size="lg"
                  style={{ color: "#99B0AD" }}
                />
              </NavButton>

              <span
                style={{ margin: "0 10px", fontSize: "16px", color: "#99B0AD" }}
              >
                {format(date, "MMMM  yyyy", { locale: pt })}
              </span>

              <NavButton onClick={increaseMonth}>
                <FontAwesomeIcon
                  icon={faChevronRight}
                  size="lg"
                  style={{ color: "#99B0AD" }}
                />
              </NavButton>
            </div>
          )}
        />
      ) : error ? (
        <h2>
          <Messages variant="danger">{error}</Messages>
        </h2>
      ) : (
        <h2>Nothing to be found</h2>
      )}
    </DatePickerWrapper>
  );
};

export default CustomDatePicker;
